import { render } from "./ViewBranding.vue?vue&type=template&id=1b360356&scoped=true"
import script from "./ViewBranding.vue?vue&type=script&lang=js"
export * from "./ViewBranding.vue?vue&type=script&lang=js"

import "./ViewBranding.vue?vue&type=style&index=0&id=1b360356&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b360356"]])

export default __exports__